module.exports = __webpack_public_path__ + "static/img/labour-love-5.3fe0403.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/labour-love-5.svg
// module id = tG4D
// module chunks = 1